import { Component } from '@angular/core';
import { Settings, Link } from '../core';

@Component({
    selector: 'kit-disclaimer',
    template: require('./kit-disclaimer.component.html'),
    styles: [require('./kit-disclaimer.component.scss')]
})
export class KitDisclaimerComponent {
    public kitDisclaimerText: string;
    public kitOrderLink: Link;

    constructor(private readonly settings: Settings) {
        this.kitOrderLink = this.settings.linksDictionary['kit-inventory'];
        this.kitDisclaimerText = 'In order to ensure accurate inventory, please inform Labcorp of expired, lost, damaged or transferred kits by going to the ';
    }
}